import React from "react";
import ReactDOM from "react-dom";
import { initEntry } from "./helper/initEntry";
import Home from "@/pages/home";

initEntry(() => {
  ReactDOM.render(
    <React.StrictMode>
      <Home />
    </React.StrictMode>,
    document.getElementById("root")
  );
});
